import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "textInput1" }
const _hoisted_2 = {
  class: "label1",
  for: "ComboBox"
}
const _hoisted_3 = { class: "input-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ComboBox = _resolveComponent("ComboBox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.Title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ComboBox, {
          "data-source": _ctx.Data.length ? _ctx.Data : [],
          height: 275,
          class: _normalizeClass({ errorStyle: _ctx.error }),
          maxlength: _ctx.max,
          filter: 'contains',
          placeholder: 'Select',
          value: _ctx.Value,
          "min-filter-length": 0,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onChange', $event.sender.value() ?? $event.sender.text()))),
          style: { width: '18.6em !important' },
          required: true
        }, null, 8, ["data-source", "class", "maxlength", "value"])
      ])
    ])
  ]))
}